var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37584 12.0958L5.94727 2.76239C6.7834 1.05532 9.21659 1.05532 10.0527 2.76239L14.6241 12.0958C14.7775 12.4087 14.886 12.7885 14.6446 13.0397C13.0476 14.701 2.95232 14.701 1.35547 13.0397C1.11396 12.7885 1.22255 12.4087 1.37584 12.0958Z",
    fill: "#FFF9DC",
    stroke: "#F9B403",
    strokeWidth: 1.69447,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96445 9.57142C7.41136 9.57142 6.91986 8.07417 6.69654 6.55477C6.5834 5.78498 7.21169 5.14285 7.98977 5.14285C8.76171 5.14285 9.3841 5.77569 9.26428 6.53827C9.03131 8.02092 8.51202 9.57142 7.96445 9.57142Z",
    fill: "#F9B403"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98186 12.5714C8.60852 12.5714 9.11653 12.0634 9.11653 11.4367C9.11653 10.81 8.60852 10.302 7.98186 10.302C7.35519 10.302 6.84718 10.81 6.84718 11.4367C6.84718 12.0634 7.35519 12.5714 7.98186 12.5714Z",
    fill: "#F9B403"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.59b97aedf1100b45133bb471eec5168c.svg";
export { ForwardRef as ReactComponent };